import React, { Component } from "react";

export class Pagination extends Component {
  render() {
    const {
      feedbacks_per_page,
      total_feedbacks,
      paginate,
      prevPage,
      nextPage,
      current_page,
    } = this.props;
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(total_feedbacks / feedbacks_per_page); i++) {
      pageNumbers.push(i);
    }

    // console.log(total_artworks);
    // console.log(pageNumbers);
    return (
      <div className="card card-custom">
        <div className="card-body py-7">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="d-flex flex-wrap mr-3">
              <nav>
                <ul className="pagination justify-content-center">
                  <li className="page-item">
                    <a
                      onClick={() => prevPage(2)}
                      className="btn btn-icon btn-sm btn-light-primary mr-2 my-1"
                      href="#"
                    >
                      <i className="fa fa-angle-double-left"></i>
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      onClick={() => prevPage(1)}
                      className="btn btn-icon btn-sm btn-light-primary mr-2 my-1"
                      href="#"
                    >
                      <i className="fa fa-chevron-left icon-xs"></i>
                    </a>
                  </li>
                  {/* {pageNumbers.map((num) => {
                    return (
                      <li className="page-item" key={num}>
                        <a
                          onClick={() => paginate(num)}
                          href="#"
                          className="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1"
                        >
                          {num}
                        </a>
                      </li>
                    );
                  })} */}
                  <li className="page-item">
                    <a
                      // onClick={() => paginate(num)}
                      href="#"
                      className="btn btn-icon btn border-0 btn-hover-primary mr-2 my-1"
                    >
                      {current_page} of {pageNumbers.length}
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      href="#"
                      class="btn btn-icon btn-sm btn-light-primary mr-2 my-1"
                      onClick={() => nextPage(1)}
                    >
                      <i class="fa fa-chevron-right icon-xs"></i>
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      onClick={() => nextPage(2)}
                      className="btn btn-icon btn-sm btn-light-primary mr-2 my-1"
                      href="#"
                    >
                      <i className="fa fa-angle-double-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Pagination;
